import { mergeStyleSets, Spinner, Stack } from '@fluentui/react';
import { useEffect, useRef, useState } from 'react';

import { popup } from '../../../../../addons/Popup';
import { getAsync } from '../../../../../utils/api';
import { actions } from '../../../slice';
import EnterPin from './EnterPin';

let requestHash: number;

export default () => {
  const [pin, setPin] = useState<number>();

  useEffect(() => {
    const hash = Date.now();
    requestHash = hash;

    if (!pin) return;

    getAsync("/employees/get?pin=" + pin).then(({ data }) => {
      if (requestHash !== hash) return;

      if (data) {
        actions.setFormVariable(["employee", data]);
      } else {
        popup("Kullanıcı bulunamadı");
        setPin(undefined);
      }
    });
  }, [pin]);

  return (
    <Stack
      className={styles.root}
      tokens={stackTokens}
      verticalAlign="center"
      horizontalAlign="center"
    >
      {pin ? <Spinner /> : <EnterPin setPin={setPin} />}
    </Stack>
  );
};

const stackTokens = { childrenGap: 5 };
const styles = mergeStyleSets({
  root: {
    width: "100%",
    height: "10vh",
  },
});
